<template>
  <section
    :id="id"
    class="dynamic-grid-item"
    :class="{ [`x${expandedCols}`]: isExpanded }"
    :style="CSS_POSITION"
    v-intersect="(entries, observer) => onIntersect(entries, observer)"
  >
    <v-lazy
      v-if="lazyLoading"
      v-model="isActive"
      :options="{ threshold: 0.5 }"
      min-height="80"
      transition="fade-transition"
    >
      <slot :expanded="isExpanded" />
    </v-lazy>
    <slot v-else :expanded="isExpanded" />

    <v-divider></v-divider>

    <v-btn icon @click="toggleExpandedView" class="ml-auto mr-0 d-block">
      <v-icon small color="#fff5">{{ isExpanded ? 'mdi-arrow-collapse' : 'mdi-arrow-expand' }}</v-icon>
    </v-btn>
  </section>
</template>

<script>
export default {
  name: 'EcsDynamicGridItem',

  props: {
    id: {
      type: String,
      default: '',
      required: true
    },
    position: {
      type: Object,
      default() {
        return { x: 0, y: 0 };
      }
    },
    maxCols: {
      type: Number,
      default: 4
    },
    expandedCols: {
      type: Number,
      default: 2,
      validator: propValue => {
        return propValue <= 12;
      }
    },
    expandedRows: {
      type: Number,
      default: 4
    },
    expanded: {
      type: Boolean,
      default: false
    },
    lazyLoading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      width: null,
      top: 0,
      left: 0,
      isExpanded: false,
      isActive: false
    };
  },

  computed: {
    CSS_POSITION() {
      return {
        '--item-top': `${this.top}px`,
        '--item-left': `${this.left}px`
      };
    }
  },

  mounted() {
    this.$el.addEventListener('transitionend', this.transitionEnded);
    this.isExpanded = this.expanded;
  },

  beforeDestroy() {
    this.$el.removeEventListener('transitionend', this.transitionEnded, true);
  },

  methods: {
    onIntersect([target]) {
      this.isActive = target.isIntersecting;
    },

    transitionEnded() {
      this.$parent.refreshGrid();
    },

    toggleExpandedView() {
      this.isExpanded = !this.isExpanded;
    }
  }
};
</script>

<style src="./scoped.scss" scoped lang="scss" />
